import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/income-statement',
}).lazy(() => import('./income-statement.lazy').then((d) => d.Route))
